import { createActionFactory } from '../../common/redux';

const { createAction, createApiFailureAction } = createActionFactory('Common Entities => rulesets => ');

const fetchRulesets = createAction('fetch rulesets');
const fetchRulesetsSuccess = createAction('fetch rulesets success', (rulesets) => ({ rulesets }));
const fetchRulesetsFailure = createApiFailureAction('fetch rulesets failure');

const cloneRuleset = createAction('clone ruleset', (rulesetId, rulesetName) => ({ rulesetId, rulesetName }));
const cloneRulesetSuccess = createAction('clone ruleset success');
const cloneRulesetFailure = createApiFailureAction('clone ruleset failure');

const createRuleset = createAction('create ruleset', (ruleset) => ({ ruleset }));
const createRulesetSuccess = createAction('create ruleset success', (ruleset) => ({ ruleset }));
const createRulesetFailure = createApiFailureAction('create ruleset failure');

const updateRuleset = createAction('update ruleset', (ruleset) => ({ ruleset }));
const updateRulesetSuccess = createAction('update ruleset success', (ruleset) => ({ ruleset }));
const updateRulesetFailure = createApiFailureAction('update ruleset failure');

const deleteRulesets = createAction('delete rulesets', (ids) => ({ ids }));
const deleteRulesetsSuccess = createAction('delete rulesets success', (ids) => ({ ids }));
const deleteRulesetsFailure = createAction('delete rulesets failure'); //this is only used for the animation of the 'save' button

const deleteRulesetsApiFailure = createApiFailureAction('delete rulesets API failure');
const deleteRulesetsPartialFailure = createAction('delete rulesets partial failure', (idsNotDeleted, idsDeleted) => ({
  idsNotDeleted,
  idsDeleted,
}));

export default {
  fetchRulesets,
  fetchRulesetsSuccess,
  fetchRulesetsFailure,
  cloneRuleset,
  cloneRulesetSuccess,
  cloneRulesetFailure,
  createRuleset,
  createRulesetSuccess,
  createRulesetFailure,
  updateRuleset,
  updateRulesetSuccess,
  updateRulesetFailure,
  deleteRulesets,
  deleteRulesetsSuccess,
  deleteRulesetsFailure,
  deleteRulesetsApiFailure,
  deleteRulesetsPartialFailure,
};
